<template>
    <div>
         <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="time">
                <el-input v-model="pgData.by1"  placeholder="标段编号" clearable></el-input>
            </el-form-item>
             <el-form-item slot="title">
                 <el-input v-model="pgData.by2"  placeholder="标段名称" clearable></el-input>
            </el-form-item>
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="标段编号" prop="bdcode" fixed min-width="200"></el-table-column>
            <el-table-column label="标段名称" prop="bdname" min-width="200"></el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                    <el-button
                    type="text"
                    icon="el-icon-warning"
                    @click="tuihui(scope.row.bdcode)">
                        退回
                    </el-button>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :action="`${getGetters('mngUrl')}/Zbdl/tuihui/get_zgscList.json`">
        </my-pagination>

        <my-dialog 
        title="退回" 
        v-model="dialogVisible" 
        width="500px"
        >
        </my-dialog>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
import DIALOG_LIST_PAGE_MIXIN from '@views/mixins/dialog-list-page'

import FormPage from './form'

export default {
    mixins: [LIST_PAGE_MIXIN, DIALOG_LIST_PAGE_MIXIN],
    components: { FormPage },
    data() {
        return {
            pgData: {
                sortname: 'a.addtime',
                sortorder: 'desc',
                pagesize: 20,
                bdcode:'',
                bdname:'',
                by1:'',
                by2:''
            },
            shbj:'',
            form: {}
        }
    },
    methods: {
        tuihui(bdcode){
            ShowConfirm('确认退回？','danger',()=> { 
                this.$post(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzgsc.json`, {
                    bdcode:bdcode
                }, (data, res) => {
                    ShowMsg(res.msg);
                    this.reloadHandler();
                });
            })
           
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/Zbdl/tuihui/thzgscinit.json`, this.data, data => {
            this.shbj=data.result
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">
</style>
